import { createSelector } from "reselect";

import { RootState } from "@store/index";
import { normalizeAdminConfigurations } from "@utils/adminConfigurationUtils";
import { AdminConfigurationsState } from "./adminConfigurationsSlice";

const adminConfigurationsState = (state: RootState) =>
  state.adminConfigurations as AdminConfigurationsState;

export const selectAdminConfigurations = createSelector(
  [adminConfigurationsState],
  // Rehydrated state can predate newer sections, so fill them from the defaults.
  (state) => normalizeAdminConfigurations(state.configurations),
);

export const selectVisualFieldAutoRestartConfiguration = createSelector(
  [selectAdminConfigurations],
  (configurations) => configurations.visualFieldAutoRestart,
);

export const selectOcularMotilityAdminConfiguration = createSelector(
  [selectAdminConfigurations],
  (configurations) => configurations.ocularMotility,
);

export const selectMovingFixationCatchTrialsEnabled = createSelector(
  [selectAdminConfigurations],
  (configurations) => configurations.visualFieldFixationLoss.movingFixationCatchTrials,
);

export const selectReadingAssessmentPageChangeInteraction = createSelector(
  [selectAdminConfigurations],
  (configurations) => configurations.readingAssessment.pageChangeInteraction,
);
